
import React, { Component } from 'react';
import { NavLink, } from 'react-router-dom';
import ReactGA from 'react-ga';
import { Auth } from 'aws-amplify';
// import Switch from '@material-ui/core/Switch';
// import Grid from '@material-ui/core/Grid';
// import charm from '../data/ImagiCharm1.png'


class NavigationBar extends Component {
    constructor(props) {
        super(props);
        this.state = {
            //charmToggleChecked: false, 
            loggedIn: false,
            username: "",
			isClicked: true
        }
    }

    componentDidMount = () => {
        this.isUserLoggedIn()
    }

    isUserLoggedIn = () => {
        Auth.currentAuthenticatedUser()
            .then(user => {
                this.setState({
                    loggedIn: true, 
                    username: user.username       
                })

            }
            )
            .catch(error => {
                console.log(error)
                this.setState({
                    loggedIn: false
                })
            }
            )

    }

    setHrefToTroubleshooting = () => {
        window.open("https://docs.google.com/document/d/1AjSlgg68i-gA06d5tyVIBkcBzDFMuFUWQZTlvEL4B30/edit")
        ReactGA.event({
            category: "User",
            action: "Troubleshooting"
        })
    }

    setHrefToWebSite = () => {
        window.open("https://imagilabs.com/")
        ReactGA.event({
            category: "User",
            action: "Click on About imagi"
        })
    }

    setHrefToFeedbackForm = () => {
        window.open("https://imagilabs.typeform.com/to/JBCpWeFo")
        ReactGA.event({
            category: "User",
            action: "Click on feedback form"
        })
    }

    // For imagiCharm bluetooth connection toggle button that is commented out below 

    // handleCharmToggleChange = () => {
    //     this.setState({
    //         charmToggleChecked : !this.state.charmToggleChecked

    //     })

    // }

    handleLogOut = async () => {
        await Auth.signOut();
        window.location.reload()

    }

    handleLogInLogOut = async () => {
        if (this.state.loggedIn) {
            await this.handleLogOut()
            
        }
    }


    render() {


        return (
            <div style={{ width: "100%", height: "5vh", marginBottom: "2vh" }}>

                <div style={{
                    height: '100%',
                    backgroundColor: "rgb(103, 212, 239)",
                    alignItems: "center",
                    display: "flex",
                    paddingLeft: "120px",
                    justifyContent: "space-between"

                }} >

				

                    <div style={{display:"flex", alignItems:"center"}}>

                        <NavLink to={{ pathname: "/app/explore" }} activeClassName="active" activeStyle={{fontWeight: "bold"}} 
						style={{ marginRight: "20px", color: "black"}}>Explore</NavLink>
                        <NavLink to={{ pathname: "/app/create" }} activeClassName="active" 
						activeStyle={{fontWeight: "bold"}} style={{ marginRight: "20px", color: "black" }}>Create</NavLink>
                        <NavLink to={{ pathname: "/app/my-projects" }} activeClassName="active" activeStyle={{fontWeight: "bold"}} 
						style={{ marginRight: "20px", color: "black" }}>My Projects</NavLink>
                        <p onClick={this.setHrefToTroubleshooting} style={{ marginRight: "20px", color: "black", textDecoration: "underline", cursor:"pointer"}}> Troubleshooting</p>
                        <p onClick={this.setHrefToWebSite} style={{ marginRight: "20px", color: "black", textDecoration: "underline", cursor:"pointer" }}> About imagi</p>
                        <p onClick={this.setHrefToFeedbackForm} style={{ color: "black", textDecoration: "underline", cursor:"pointer" }}> Share your thoughts on this prototype! </p>

                        
                    </div >

                    <div style={{ display:"flex", alignItems:"center", marginRight:"5%"}}>
                        <p>
                        {this.state.loggedIn ? `Hi, ${this.state.username}!`:""}
                        </p>
                        <NavLink to={{ pathname: (this.state.loggedIn?"" :"/") }} style={{ marginLeft: "20px" }}><button style={{fontSize:"16px"}} onClick={this.handleLogInLogOut}>{this.state.loggedIn ? `Log out` : ("Log in")}</button></NavLink>
                        </div>



                    {/* 

                    Toggle button for globally switching on and off the bluetooth connection - for future when it is possible

                    <Grid container alignItems="center" justify="flex-end" spacing={1}>
                        <img style={{marginRight:"1%"}} src={charm}/>
                        <Grid item>Off</Grid>
                        <Grid item>
                            <Switch onClick={this.handleCharmToggleChange} checked={this.state.charmToggleChecked} color='primary' name="checkedA" />
                        </Grid>
                        <Grid item>Connected</Grid>
                        <div style={{marginRight:"10%"}}></div>

                       
                       
                    </Grid> */}


                </div>


            </div>




        )
    }
}
export default NavigationBar;